import { EmailSchema, PhoneSchema } from "@/utils/commonSchema";
import {
  boolean,
  isoDate,
  nonEmpty,
  null_,
  number,
  object,
  objectAsync,
  optional,
  picklist,
  pipe,
  string,
  trim,
  unionAsync,
} from "valibot";

export const RequestProgramAddressInputSchema = objectAsync({
  title: picklist(["Mme", "M."]),
  firstname: pipe(string("Prénom requis"), trim(), nonEmpty("Prénom requis")),
  lastname: pipe(string("Nom requis"), trim(), nonEmpty("Nom requis")),
  birthdate: pipe(
    string("Date de naissance requise"),
    nonEmpty("Date de naissance requise"),
    isoDate("Date de naissance requise"),
  ),
  email: EmailSchema,
  address1: pipe(string("Adresse requise"), trim(), nonEmpty("Adresse requise")),
  address2: optional(string()),
  zip: pipe(string("Code postal requis"), trim(), nonEmpty("Code postal requis")),
  city: pipe(string("Ville requise"), trim(), nonEmpty("Ville requise")),
  countryId: string("Pays requis"),
  telephone: unionAsync([PhoneSchema, null_()]),
  brochureOperationId: number(),
});

export const RequestProgramAddressOutputSchema = object({
  success: boolean(),
});

export type RequestProgramAddressInputSchema = typeof RequestProgramAddressInputSchema;
export type RequestProgramAddressOutputSchema = typeof RequestProgramAddressOutputSchema;
